import axios from "axios";

// Use a relative /api path so requests always hit the SAME ORIGIN as the frontend.
// This avoids cross-origin / Safari iOS ITP / CORS-with-credentials issues entirely.
// REACT_APP_BACKEND_URL is kept as an opt-in override (e.g. for local dev pointing
// at a different host), but in normal preview/production deploys we stay same-origin.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL_OVERRIDE || "";
export const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Add bearer fallback from localStorage so non-cookie environments still work
api.interceptors.request.use((config) => {
  const t = typeof window !== "undefined" ? localStorage.getItem("session_token") : null;
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const formatEUR = (v) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v);
